export default {
    name: 'pp-list-label',
    props: {
        render: Object,
    },
    render: function() {
        return this.render;
    },
}